<template>
  <section>
    <leftMenu />
    <modal-refunds :data-modal="dataModal"
                   :solicitation-refund-id="solicitationRefundId"
                   :solicitation-team="solicitationTeam"
                   :actionReload.sync="reloadRequest"/>

    <div id="mainContent" class="card-content-default refunds">
      <div v-if="!refundPolicy" class="row">
        <!-- TITLE -->
        <div class="col-xs-12 col-sm-12 col-md-12 refunds-title">
          <h1 class="certa">Reembolsos</h1>
          <div v-if="!showAllMenu.isManager" class="refunds-header">
            <div class="refunds-request">
              <span class="certa refunds-btn" v-on:click="openModalRefunds(1)">Solicitar reembolso</span>
              <span id="openRequestRefundAgain" v-on:click="openModalRefunds(3)" style="display: none"></span>
            </div>
          </div>
        </div>
        <!-- NAVEGATION TOP -->
        <div v-if="showAllMenu.isManager" class="col-xs-12 col-sm-12 col-md-12 offset-top-30 refunds-header">
          <div class="refunds-navigation">
            <span @click="changeNav(0)" id="navOne" class="active">Minhas solicitações</span>
            <span @click="changeNav(1)" id="navTwo" class="">Solicitações da equipe</span>
          </div>
          <div class="refunds-request">
            <span class="certa refunds-btn" v-on:click="openModalRefunds(1)">Solicitar reembolso</span>
          </div>
        </div>
        <!-- LOADING DEFAULT -->
        <loading-page v-if="loading" />
        <!-- CONTENT PAGE -->
        <div class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-30 refunds-content">
          <div class="col-xs-12 col-sm-12 col-md-12 refunds-box">
            <div class="refunds-search">
              <div class="col-12 search-title">
                <h2 class="certa">Lista de Reembolsos</h2>
                <span @click="policyRefund(true)" class="policy-refund">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.16663 7.50008H10.8333V5.83341H9.16663V7.50008ZM9.99996 16.6667C6.32496 16.6667 3.33329 13.6751 3.33329 10.0001C3.33329 6.32508 6.32496 3.33341 9.99996 3.33341C13.675 3.33341 16.6666 6.32508 16.6666 10.0001C16.6666 13.6751 13.675 16.6667 9.99996 16.6667ZM9.99996 1.66675C8.90561 1.66675 7.82198 1.8823 6.81093 2.30109C5.79988 2.71987 4.88122 3.3337 4.1074 4.10752C2.5446 5.67033 1.66663 7.78994 1.66663 10.0001C1.66663 12.2102 2.5446 14.3298 4.1074 15.8926C4.88122 16.6665 5.79988 17.2803 6.81093 17.6991C7.82198 18.1179 8.90561 18.3334 9.99996 18.3334C12.2101 18.3334 14.3297 17.4554 15.8925 15.8926C17.4553 14.3298 18.3333 12.2102 18.3333 10.0001C18.3333 8.90573 18.1177 7.8221 17.699 6.81105C17.2802 5.80001 16.6663 4.88135 15.8925 4.10752C15.1187 3.3337 14.2 2.71987 13.189 2.30109C12.1779 1.8823 11.0943 1.66675 9.99996 1.66675ZM9.16663 14.1667H10.8333V9.16675H9.16663V14.1667Z" fill="#352DA5"/>
                  </svg>
                  <span class="policy-content">Ver a política de reembolsos da empresa</span>
                </span>
              </div>
              <div class="search-content">
                <span class="nunito">Filtrar por data da solicitação</span>
                <div class="col-xs-12 col-sm-12 col-md-12 search-data">
                  <datapickerRange col-bootstrap="col-xs-8 col-sm-6 col-md-3"/>
                  <span @click="getData(1)" class="certa search-btn">Pesquisar</span>
                </div>
              </div>
            </div>
            <div v-if="!loading" class="refunds-table">
              <div v-if="refundsNav === 0">
                <div v-if="dataCodeEmployee.items.length === 0" class="empty-state">
                  <img src="../../../../assets/img/empty/comunicados.png" alt="Nenhuma solicitação">
                  <p>Você ainda não recebeu nenhuma solicitação de reembolso até o momento.</p>
                </div>
                <table v-else class="table table-responsive table-clean">
                  <thead>
                  <tr>
                    <th class="certa no-wrap">Data da despesa</th>
                    <th class="certa no-wrap">Categoria</th>
                    <th class="certa no-wrap">Status</th>
                    <th class="certa no-wrap">Valor</th>
                    <th class="certa no-wrap">Observação</th>
                    <th class="certa no-wrap">Solicitado em</th>
                    <th class="certa no-wrap">Ações</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(value, index) in dataCodeEmployee.items" :key="index">
                    <td class="requested-at">{{ value.expenseDate | formatDate }}</td>
                    <td>{{ value.refundCategory }}</td>
                    <td class="status-tags">
                      <span v-if="value.userRefundStatus === 0" class="uninformed">Não informado</span>
                      <span v-if="value.userRefundStatus === 1" class="pending">Pendente</span>
                      <span v-if="value.userRefundStatus === 4" class="analysis">Em análise</span>
                      <span v-if="value.userRefundStatus === 2 && value.userRefundStatusPayment !== 2" class="approved">Aprovado</span>
                      <span v-if="value.userRefundStatus === 3" class="refused">Recusado</span>
                      <div v-if="value.userRefundStatus === 2 && value.userRefundStatusPayment === 2" class="tag-card">
                        <span class="approved">Aprovado</span>
                        <span class="pay-card">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.5 6C10.5 3.51562 8.48438 1.5 6 1.5C3.51562 1.5 1.5 3.51562 1.5 6C1.5 8.48438 3.51562 10.5 6 10.5C8.48438 10.5 10.5 8.48438 10.5 6Z" stroke="#2ACC6B" stroke-width="0.75" stroke-miterlimit="10"/>
                          <path d="M8.25 4.125L5.1 7.875L3.75 6.375" stroke="#2ACC6B" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Pago no cartão</span>
                      </div>
                    </td>
                    <td>{{ value.value | formatMoney }}</td>
                    <td class="obs">{{ value.message }}</td>
                    <td class="requested-at">{{ value.requestedAt | formatDate }}</td>
                    <td class="requests">
                      <span @click="openModalRefunds(2, value.id, false)">Ver solicitação</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="refundsNav === 1">
                <div v-if="dataCodeTeam.items.length === 0" class="empty-state">
                  <img src="../../../../assets/img/empty/comunicados.png" alt="Nenhuma solicitação">
                  <p>Você ainda não recebeu nenhuma solicitação de reembolso até o momento.</p>
                </div>
                <table v-else class="table table-responsive table-clean">
                  <thead>
                  <tr>
                    <th class="certa no-wrap">Funcionário</th>
                    <th class="certa no-wrap">Categoria</th>
                    <th class="certa no-wrap">Status</th>
                    <th class="certa no-wrap">Valor</th>
                    <th class="certa no-wrap">Observação</th>
                    <th class="certa no-wrap">Solicitado em</th>
                    <th class="certa no-wrap">Ações</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(value, index) in dataCodeTeam.items" :key="index">
                    <td class="content-photo">
                      <div class="photo">
                        <img v-if="value.photoUri !== null || ''" :src="value.photoUri" alt="Foto" />
                        <img v-else src="../../../../assets/img/user-default.png" alt="Foto" />
                      </div>
                      <a class="no-link">
                        <span>{{ value.name }}</span>
                      </a>
                      <p class="office">{{ value.officeName }}</p>
                    </td>
                    <td>{{ value.refundCategory }}</td>
                    <td class="status-tags">
                      <span v-if="value.userRefundStatus === 0" class="uninformed">Não informado</span>
                      <span v-if="value.userRefundStatus === 1" class="pending">Pendente</span>
                      <span v-if="value.userRefundStatus === 4" class="analysis">Em análise</span>
                      <span v-if="value.userRefundStatus === 2 && value.userRefundStatusPayment !== 2" class="approved">Aprovado</span>
                      <span v-if="value.userRefundStatus === 3" class="refused">Recusado</span>
                      <div v-if="value.userRefundStatus === 2 && value.userRefundStatusPayment === 2" class="tag-card">
                        <span class="approved">Aprovado</span>
                        <span class="pay-card">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.5 6C10.5 3.51562 8.48438 1.5 6 1.5C3.51562 1.5 1.5 3.51562 1.5 6C1.5 8.48438 3.51562 10.5 6 10.5C8.48438 10.5 10.5 8.48438 10.5 6Z" stroke="#2ACC6B" stroke-width="0.75" stroke-miterlimit="10"/>
                          <path d="M8.25 4.125L5.1 7.875L3.75 6.375" stroke="#2ACC6B" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Pago no cartão</span>
                      </div>
                    </td>
                    <td>{{ value.value | formatMoney }}</td>
                    <td class="obs">{{ value.message }}</td>
                    <td class="requested-at">{{ value.requestedAt | formatDate}}</td>
                    <td class="requests">
                      <span @click="openModalRefunds(2, value.id, true)">Ver solicitação</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="refundPolicy" class="row">
        <!-- TITLE POLICY -->
        <div class="col-xs-12 col-sm-12 col-md-12 policy-title">
          <h1 @click="policyRefund(false)" class="certa">
            <ion-icon name="arrow-back-outline"></ion-icon>
            <span>Voltar</span>
          </h1>
        </div>
        <!-- POLICY CONTENT -->
        <div class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-30 policy-body">
          <h1>Política de Reembolsos</h1>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 policy-box">
            <h2>Política de Reembolsos da empresa</h2>
            <div>
              <p>{{ dataPolicies.policyDescription }}</p>
            </div>
            <div class="policy-attachments">
              <span @click="policyPdf(dataPolicies.attachmentPolicyUri)" class="btn-policy">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.6667 1.66675H6.66675C5.75008 1.66675 5.00008 2.41675 5.00008 3.33341V13.3334C5.00008 14.2501 5.75008 15.0001 6.66675 15.0001H16.6667C17.5834 15.0001 18.3334 14.2501 18.3334 13.3334V3.33341C18.3334 2.41675 17.5834 1.66675 16.6667 1.66675ZM9.58341 7.91675C9.58341 8.60841 9.02508 9.16675 8.33341 9.16675H7.50008V10.8334H6.25008V5.83341H8.33341C9.02508 5.83341 9.58341 6.39175 9.58341 7.08341V7.91675ZM13.7501 9.58341C13.7501 10.2751 13.1917 10.8334 12.5001 10.8334H10.4167V5.83341H12.5001C13.1917 5.83341 13.7501 6.39175 13.7501 7.08341V9.58341ZM17.0834 7.08341H15.8334V7.91675H17.0834V9.16675H15.8334V10.8334H14.5834V5.83341H17.0834V7.08341ZM7.50008 7.91675H8.33341V7.08341H7.50008V7.91675ZM3.33341 5.00008H1.66675V16.6667C1.66675 17.5834 2.41675 18.3334 3.33341 18.3334H15.0001V16.6667H3.33341V5.00008ZM11.6667 9.58341H12.5001V7.08341H11.6667V9.58341Z" fill="white"/>
                </svg>
                Fazer download do documento
              </span>
            </div>
            <div class="policy-category">
              <h2>Categorias de despesas disponíveis</h2>
              <ul>
                <li v-for="(value, index) in dataPolicies.categories.items" :key="index" :title="value.description">{{ value.name }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
import leftMenu from '../../components/leftMenu.vue';
import loadingPage from '../../components/loadingPage.vue';
import datapickerRange from '../../components/datapickerRange.vue';
import modalRefunds from '../../modals/modalRefunds.vue';
import {
  REFUND_POLICY,
  REFUNDS_COLLABORATOR,
  REFUNDS_MANAGER
} from "../../../../urlConfig";
import {UTIL_SERVICE} from "../../../../utils";
import {REQUEST_SERVICE} from "../../../../requestConfig";
import vueFooter from "../../components/footer.vue";

export default {
  name: "refunds",
  components: {
    vueFooter,
    leftMenu,
    loadingPage,
    datapickerRange,
    modalRefunds,
  },
  data() {
    return {
      reloadRequest: '',
      loading: false,
      refundsNav: 0,
      dataModal: '',
      solicitationTeam: false,
      solicitationRefundId: '',
      showAllMenu: '',
      dataCodeTeam: '',
      dataCodeEmployee: '',
      dataPolicies: '',
      filterDataRange: '',
      refundPolicy: false,
    }
  },
  methods: {
    checkTeam() {
      const value = UTIL_SERVICE.getStorage('configMenu')
      if(value) {
        this.showAllMenu = value
      }
    },
    policyPdf(url) {
      window.open(url);
    },
    policyRefund(value) {
      this.refundPolicy = value
    },
    changeNav(value) {
      this.refundsNav = value


      if(value === 0) {
        $("#navTwo").removeClass('active')
        $("#navOne").addClass('active')
      } else {
        $("#navOne").removeClass('active')
        $("#navTwo").addClass('active')
      }
      this.getData()
    },
    openModalRefunds(type, id, solicitation) {
      this.dataModal = {};
      this.dataModal.modalType = type;
      this.dataModal.isManager = this.showAllMenu.isManager

      this.solicitationTeam = solicitation
      this.solicitationRefundId = id;

      $("#modalRefunds").modal({backdrop: 'static',keyboard: false});
    },
    getData(){
      this.loading = true

      const filterDate = '?initDate=' + this.$route.params.dateInit + '&endDate=' + this.$route.params.dateEnd + '&r=1000'

      if(this.showAllMenu.isManager === true) {
        if(this.refundsNav === 0) {
          REQUEST_SERVICE.get(REFUNDS_COLLABORATOR + filterDate).then((response) => {
            UTIL_SERVICE.console("RESULT REFUNDS_COLLABORATOR:", response.data);

            this.dataCodeEmployee = response.data;
            this.loading = false;

          }).catch(reason => {
            this.loading = false;
          });
        }

        if(this.refundsNav === 1) {
          REQUEST_SERVICE.get(REFUNDS_MANAGER + filterDate).then((response) => {
            UTIL_SERVICE.console("RESULT REFUNDS_MANAGER:", response.data);

            this.dataCodeTeam = response.data;
            this.loading = false;

          }).catch(reason => {
            this.loading = false;
          });
        }
      }

      if(this.showAllMenu.isManager === false) {
        REQUEST_SERVICE.get(REFUNDS_COLLABORATOR + filterDate).then((response) => {
          UTIL_SERVICE.console("RESULT REFUNDS_COLLABORATOR:", response.data);

          this.dataCodeEmployee = response.data;
          this.loading = false;

        }).catch(reason => {
          this.loading = false;
        });
      }
    },
    getPolicies() {
      REQUEST_SERVICE.get(REFUND_POLICY).then((response) => {
        UTIL_SERVICE.console("RESULT REFUND_POLICY:", response.data);
        this.dataPolicies = response.data;
      }).catch(reason => {
        console.log(reason)
      });
    },
  },
  beforeMount() {
    this.checkTeam();
    this.getData();
    this.getPolicies();
  },
  watch: {
    reloadRequest: function (response) {
      this.getData();
    }
  }
}
</script>

<style lang="scss">

body {
  font-family: "Montserrat", sans-serif;
}

.refunds {
  background: var(--bodyColor);
  padding-bottom: 5% !important;
  padding-right: 3% !important;
  height: 100%;

  .refunds-title {
    display: flex;
    justify-content: space-between;

    h1 {
      font-size: 28px;
      color: var(--titleBox);
    }
  }

  .policy-title {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid var(--btnBkSide);
    padding-bottom: 5px;

    h1 {
      display: flex;
      align-items: center;

      font-weight: 400;
      font-size: 21px;
      color: var(--textActiveSide);

      &:hover {
        text-decoration: underline;
      }

      span {
        cursor: pointer;
        color: var(--textActiveSide);
      }

      ion-icon {
        margin-right: 9px;
        cursor: pointer;
        color: var(--textActiveSide);
      }
    }
  }

  .refunds-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .refunds-navigation {
      display: inline-block;
      border-radius: 30px;
      padding: 0;
      background: rgba(127, 136, 151, 0.25);

      span {
        font-size: 14px;
        font-weight: 400;
        display: inline-block;
        border-radius: 30px;
        padding: 7px 13px;
        cursor: pointer;
        color: var(--defaultText);
        transition: .2s;

        &:hover {
          background: var(--linkColor);
          color: #ffffff;
        }
      }

      .active {
        background: var(--textActiveSide);
        color: #FFFFFF;
      }
    }

    .refunds-request {
      float: right;

      .refunds-btn {
        border-radius: 4px;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;

        background: var(--linkColor);
        border: 1px solid var(--linkColor);
        color: #ffffff;
        margin-left: 14px;
        padding: 8px 16px;
        cursor: pointer;
        transition: .2s;

        &:hover {
          background: #2e278e;
        }
      }
    }
  }

  .refunds-content {
    .refunds-box {
      padding: 10px 30px;
      background: var(--bodyContrast) 0 0 no-repeat padding-box;
      box-shadow: 0 0 15px #0000000d;
      border-radius: 12px;

      .refunds-search {
        .search-title {
          position: relative;

          h2 {
            font-size: 24px;
            color: var(--titleBox);
            margin-bottom: 20px;
          }

          .policy-refund {
            position: absolute;
            right: 0;
            top: 0;

            display: flex;
            justify-content: flex-end;
            width: fit-content;
            font-size: 14px;
            font-weight: 400;
            color: var(--textActiveSide);
            cursor: pointer;

            @media only screen and(max-width: 950px) {
              width: 35% !important;
            }

            &:hover {
              text-decoration: underline;
            }

            .policy-content {
              color: var(--textActiveSide);
            }

            svg {
              margin-right: 9px;

              path {
                fill: var(--textActiveSide);
              }
            }
          }
        }

        .search-content {
          padding: 0;
          margin-bottom: 30px;

          span {
            margin-bottom: 3px;
            color: var(--defaultText);
          }

          .search-data {
            float: none !important;

            display: flex;
            padding: 0;
            margin-top: 3px;

            .search-btn {
              border-radius: 4px;
              font-style: normal;
              font-weight: 500;
              font-size: 14px;
              background: var(--linkColor);
              border: 1px solid var(--linkColor);
              color: #ffffff;
              margin: 0 0 0 20px;
              padding: 6px 16px;
              cursor: pointer;
              transition: .2s;

              &:hover {
                background: #2e278e;
              }
            }
          }
        }
      }

      .refunds-table {
        overflow-x: auto;

        .empty-state {
          img {
            margin-top: 40px;
          }

          p {
            color: var(--defaultText);
            font-size: 18px;
            margin-top: 30px;
            margin-bottom: 20px;
          }
        }

        .table {
          width: 100%;
          max-width: 100%;
          margin-bottom: 20px;

          thead {
            tr {
              th {
                font-weight: normal;
                font-size: 15px;
                border-bottom: none;
              }
            }
          }

          tbody {
            tr {
              td {
                font-size: 14px;
                font-weight: 400;
                line-height: 18px;

                .uninformed {
                  color: #FFFFFF;
                  background: #7F8897;
                  padding: 6px 9px;
                  border-radius: 4px;
                }

                .pending {
                  color: #3A424E;
                  background: #FDD944;
                  padding: 6px 27px;
                  border-radius: 4px;
                }

                .analysis {
                  color: #ffffff;
                  background: #FF9900;
                  padding: 6px 23.2px;
                  border-radius: 4px;
                }

                .approved {
                  color: #ffffff;
                  background: #2ACC6B;
                  padding: 6px 28px;
                  border-radius: 4px;
                }

                .refused {
                  color: #ffffff;
                  background: var(--redColor);
                  padding: 6px 27px;
                  border-radius: 4px;
                }

                .tag-card {
                  display: flex;
                  flex-direction: column;

                  .pay-card {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    color: var(--textSide);
                    font-size: 12px;
                    font-weight: 400;
                    margin-top: 5px;
                  }
                }
              }

              .status-tags {
                display: flex;
              }

              .obs {
                max-width: 150px;
                word-break: break-all;
              }

              .requested-at {
                font-family: "Montserrat", sans-serif;
                color: var(--defaultText);
              }

              .requests {
                span {
                  font-family: "Montserrat", sans-serif;
                  cursor: pointer;
                  margin-top: 0;
                  display: inline-block;
                  border: 1px solid var(--linkColor);
                  color: var(--linkColor);
                  background-color: transparent;
                  border-radius: 25px;
                  padding: 5px 10px;
                  font-size: 12px;
                  white-space: nowrap;
                  transition: .2s;

                  &:hover {
                    color: #ffffff;
                    background-color: var(--linkColor);
                  }
                }
              }

              .content-photo {
                white-space: nowrap;
                height: 70px;
                position: relative;

                .photo {
                  width: 48px;
                  height: 48px;
                  background: var(--bodyColor);
                  border-radius: 50%;
                  position: absolute;
                  margin-top: 1px;

                  img {
                    width: 48px;
                    height: 48px;
                    position: absolute;
                    border-radius: 100%;
                    top: 0;
                    left: 0;
                    object-fit: cover;
                  }

                  p {
                    text-align: center;
                    line-height: 48px;
                    font-weight: bold;
                    text-transform: uppercase;
                    font-size: 18px;
                    font-family: "Montserrat", sans-serif;
                  }
                }

                .no-link {
                  margin-left: 58px;
                  font-family: "Montserrat", sans-serif;
                  font-style: normal;
                  font-weight: 500;
                  font-size: 16px;
                  line-height: 20px;
                  color: var(--titleBox);
                  display: inline-block;
                  cursor: default;
                  margin-top: 4px;
                  margin-bottom: 1px;
                  min-height: 21px;

                  &:hover {
                    text-decoration: none;
                    color: var(--titleBox) !important;
                  }

                  span {
                    margin-right: 4px;
                  }
                }

                .office {
                  padding-left: 58px;
                  font-size: 12px;
                  margin: 0;
                  color: var(--defaultText);
                }
              }
            }
          }
        }
      }
    }
  }

  .policy-body {
    h1 {
      font-size: 36px;
      color: var(--titleBox);
      margin-bottom: 20px;
    }

    .policy-box {
      padding: 10px 30px;
      background: var(--bodyContrast) 0 0 no-repeat padding-box;
      box-shadow: 0 0 15px #0000000d;
      border-radius: 12px;

      h2 {
        font-weight: 700;
        font-size: 21px;
        color: var(--titleBox);
        margin-bottom: 16px;
      }

      p {
        font-weight: 400;
        font-size: 14px;
        color: var(--textSide);
        line-height: 140%;
      }

      .policy-attachments {
        margin: 30px 0;
        .btn-policy {
          display: flex;
          align-items: center;

          background-color: var(--iconActiveSide);
          padding: 8px 34px;
          color: #ffffff;
          border-radius: 4px;
          width: fit-content;
          cursor: pointer;

          &:hover {
            background: #2e278e;
          }

          svg {
            margin-right: 9px;
            path {
              fill: #ffffff;
            }
          }
        }
      }

      .policy-category {
        h2 {
          font-weight: 700;
          font-size: 21px;
          color: var(--titleBox);
          margin-bottom: 15px;
        }

        ul {
          color: var(--textSide);
          font-size: 14px;
          font-weight: 400;
          list-style-type: disclosure-closed;
          padding: 0 0 0 18px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/refunds/refunds.vue